<div class="relative flex min-h-screen flex-col justify-center overflow-hidden">
  <div class="relative bg-white px-6 pt-10 pb-9 shadow-xl mx-auto w-full max-w-lg rounded-2xl">
    <div class="mx-auto flex w-full max-w-md flex-col space-y-16">
      <div class="flex flex-col items-center justify-center text-center space-y-2">
        <div class="font-semibold text-3xl">
          <p>Email Verification</p>
        </div>
        <div class="flex flex-row text-sm font-medium text-gray-400">
          <p>We have sent a code to your email {{ user?.email }}</p>
        </div>


      </div>

      <div>
        <form [formGroup]="emailVerifyForm" (ngSubmit)="onSubmit()">
          <div *ngIf="errorMessage" class="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50" role="alert">
            <span class="font-medium">{{ errorMessage }}</span>
          </div>
          <div class="flex flex-col space-y-16">
            <div class="flex flex-row items-center justify-between mx-auto w-full">
              <div class="w-full">
                <label for="otp" class="block mb-2 text-sm font-medium text-gray-900">Enter OTP</label>
                <input type="text" pattern="[0-9]*" maxlength="10" name="otp" formControlName="otp" id="otp"
                  placeholder="••••••••"
                  class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                  required="">
                <div *ngIf="emailVerifyForm.get('otp')?.hasError('required') && emailVerifyForm.get('otp')?.touched"
                  class="text-red-500 text-sm font-medium absolute">
                  OTP is required
                </div>
                <div *ngIf="emailVerifyForm.get('otp')?.hasError('minlength')"
                  class="text-red-500 text-sm font-medium absolute">OTP must be at least 6 characters long.</div>

              </div>

            </div>

            <div class="flex flex-col space-y-5">
              <div>
                <button [disabled]="emailVerifyForm.invalid"
                  class="flex flex-row items-center justify-center text-center w-full border rounded-xl outline-none py-2 bg-primary-700 border-none text-white text-sm shadow-sm">

                  <ng-container *ngIf="!isLoading">Verify your account</ng-container>

                  <ng-container *ngIf="isLoading">
                    <svg aria-hidden="true" class="w-6 h-6 text-primary-200 animate-spin fill-primary-700"
                      viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill" />
                    </svg>
                    <span class="sr-only">Loading...</span>
                  </ng-container>

                </button>
              </div>

              <div
                class="flex flex-row items-center justify-center text-center text-sm font-medium space-x-1 text-gray-500">
                <p>Didn't recieve code?</p> <a class="flex flex-row items-center text-primary-600" href="http://"
                  target="_blank" rel="noopener noreferrer">Resend</a>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>